import { useQuery } from '@tanstack/react-query';

import {
  BasketViewModel,
  HotelGetAdvancePaymentRequestViewModel,
} from '@api/index';
import { callService } from '@api/caller';
import { isClientSide } from '@utils/env';

export const getBasketFromCache = (): BasketViewModel | undefined => {
  if (typeof window !== 'undefined') {
    const basketDetail = localStorage.getItem('basketDetail');
    return basketDetail ? JSON.parse(basketDetail) : undefined;
  }
};

export const useBasketId = (): string | undefined => {
  if (typeof window !== 'undefined') {
    try {
      const basketId = localStorage.getItem('basketId');
      return basketId ?? undefined;
    } catch (error) {
      console.error('Error retrieving basketId from localStorage:', error);
      return undefined;
    }
  }
};

export const useIsKocAilemValidated = (): boolean => {
  if (typeof window === 'undefined') return false;
  return localStorage.getItem('hasKocAilemLoyalty') === 'true' ? true : false;
};

export const getLoyalties = () => {
  const loyaltiesString = localStorage.getItem('loyalties');
  return loyaltiesString ? JSON.parse(loyaltiesString) : {};
};

export const storeLoyalty = <V>(loyalty: string, value?: V) => {
  if (isClientSide()) {
    const loyaltiesString = localStorage.getItem('loyalties');
    const loyalties = loyaltiesString ? JSON.parse(loyaltiesString) : {};
    loyalties[loyalty.toLowerCase()] = value;
    localStorage.setItem('loyalties', JSON.stringify(loyalties));
  }
};

export const useHotelsItemIds = (): string[] => {
  const basket = getBasketFromCache();
  return (
    basket?.hotels?.map((hotel) => hotel.itemId as NonNullable<string>) ?? []
  );
};
export const useFlightsItemIds = (): string[] => {
  const basket = getBasketFromCache();
  return (
    basket?.flights?.map((flight) => flight.itemId as NonNullable<string>) ?? []
  );
};

export const useIsDomesticFlight = (index = 0) => {
  const basket = getBasketFromCache();
  return basket?.flights?.[index]?.domestic ?? true;
};

export const useCanPayWithAdvance = (
  body?: HotelGetAdvancePaymentRequestViewModel,
  enabled?: boolean
) => {
  const { data } = useQuery(
    ['pay'],
    async () => callService('PaymentsService', 'advancePaymentHotel', { body }),
    {
      enabled: enabled,
      cacheTime: Infinity,
      staleTime: Infinity,
      onSuccess: (data) => {
        if (typeof window !== 'undefined') {
          localStorage.setItem('advanceDeadline', `${data.deadLine}`);
        }
      },
    }
  );
  const deadLine =
    typeof window !== 'undefined'
      ? +(localStorage.getItem('advanceDeadline') || 0)
      : undefined;
  return (
    data ??
    ({ deadLine, hasAdvancePayment: false, rate: 0 } as NonNullable<
      typeof data
    >)
  );
};
